var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122.88,
    height: 122.88,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 514,
    width: 514,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007fff",
    id: "svg_2",
    d: "m61.44,0c33.93,0 61.44,27.51 61.44,61.44c0,33.93 -27.51,61.44 -61.44,61.44s-61.44,-27.51 -61.44,-61.44c0,-33.93 27.51,-61.44 61.44,-61.44l0,0zm-8.88,84c-1.82,0.61 -3.68,1.17 -5.5,1.77c-1.82,0.61 -3.64,1.21 -5.5,1.82c-4.34,1.4 -6.71,2.19 -7.23,2.33c-0.51,0.14 -0.19,-1.86 0.89,-6.06l3.45,-13.19l26.01,-27.04l13.85,13.33l-25.97,27.04l0,0l0,0zm25.92,-50.16c-0.65,-0.61 -1.4,-0.93 -2.24,-0.89c-0.84,0 -1.59,0.33 -2.19,0.98l-4.94,5.13l13.85,13.38l4.99,-5.22c0.61,-0.61 0.84,-1.4 0.84,-2.24c0,-0.84 -0.33,-1.63 -0.93,-2.19l-9.38,-8.95l0,0l0,0z",
    className: "st0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/edit_blue.69296708eb25430b3c5cbf0ba3f6ad11.svg";
export { ForwardRef as ReactComponent };